import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-apartment",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: "",
        userTypeAccountStatus: -1
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id,
          from: this.$operationLog.editFrom({
            user_type: row.userInfo.user_type,
            status: row.status
          })
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var price, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              if (_this2.searchForm.priceId && _this2.searchForm.priceId.length > 0) {
                price = _this2.searchForm.priceId.split(",");
                _this2.searchForm.minPrice = price[0];
                _this2.searchForm.maxPrice = price[1];
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getBrandHouseList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.list;
              _this2.total = res.data.count;
              _this2.tableLoading = false;
              _this2.getUserListByIds(_this2.tableData, "userId");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getHouseFilterType();
            case 1:
              res = _context3.v;
              _this3.filterList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this4 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this4.searchForm.districtId = "";
            _this4.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    }
  }
};